export const NAME = 50;
export const DAY = 2;
export const TELEPHONE = 12;
export const POSTCODE_MAX = 8;
export const POSTCODE_MIN = 5;
export const EMAIL = 50;
export const ROOMS = 3;
export const YEAR = 4;
export const INSURED_ITEM_MAX_VALUE = 6;
export const YEARS_LIVED = 3;
export const BUILD_SUMS_INS_MAX = 8;
export const CONTENTS_SUMS_INS_MAX = 6;
export const CLAIM_AMOUNT = 6;
export const ITEM_DESCRIPTION_MAX = 40;
